import React from 'react'
import { DashboardLayout } from '../layouts'
import { AddAdminForm } from '../containers'
import ChangePasswordForm from '../containers/Forms/ChangePasswordForm'

function ChangePassword() {
  return (
    <DashboardLayout>
        <div>

            <ChangePasswordForm/>
            {/* <h1>Chnage Password</h1> */}

        </div>

    </DashboardLayout>
  )
}

export default ChangePassword